import _ from '@lodash';
import { Dialog } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';

class XAPPDialog extends XAPPComponent {

    state = {
        open: false
    }

    componentDidUpdate(prevProps) {
        const { open, mensagem = null } = this.props;

        if (!_.isEqual(open, this.state.open)) {
            this.setState(_.set({ ...this.state }, "open", open));
        }
    }



    render() {
        const { children, className, classes, fullWidth, maxWidth, fullScreen, theme, TransitionComponent, style, id } = this.props;
        const { open } = this.state;
        const stopPropagationForTab = (event) => {
            if (event.key === "Tab") {
                event.stopPropagation();
            }
        };

        return (
            <React.Fragment>
                <Dialog
                    id={id}
                    key={id}
                    onKeyDown={stopPropagationForTab}
                    classes={classes}
                    TransitionComponent={TransitionComponent}
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    fullScreen={fullScreen}
                    theme={theme}
                    open={open}
                    onClose={() => { }}
                    style={style}
                    className={className}
                >
                    {children}
                </Dialog>
            </React.Fragment>
        )
    }
}

export default XAPPDialog;
